import React from 'react'
import { Button, SectionTitleSkeleton } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import * as S from './../pulseSurveyLink.styles'

export const PulseSurveyLinkSkeleton = () => {
    return (
        <S.PulseSurveyLinkWrapper>
            <S.Header>
                <SectionTitleSkeleton />

                <S.Description>
                    <Skeleton width={120} />
                </S.Description>
            </S.Header>

            <S.LinkContainer>
                <S.LinkInput type="text" value="" readOnly />

                <Button color="primary">
                    <Skeleton width={40} />
                </Button>
            </S.LinkContainer>
        </S.PulseSurveyLinkWrapper>
    )
}
